type GalleryProps = {
  images: string[];
  onSelect: (url: string) => void;
  current: string;
  name: string;
};

export default function RenderGallery({
  images,
  onSelect,
  current,
  name,
}: GalleryProps) {
  return (
    <div className="gallery">
      {images.map((img, index) => (
        <button
          key={img}
          type="button"
          onClick={() => onSelect(img)}
          aria-label={`Afficher ${name} – photo ${index + 1}`}
          className={`thumb ${current === img ? "active" : ""}`}
        >
          <img src={img} alt="" loading="lazy" decoding="async" />
        </button>
      ))}
    </div>
  );
}
